import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle } from '@mui/material';
import React from 'react';


interface props{
    children: any,
    buttonContent: string,
    title: string,
    className?: string,
    dialogWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    scrollType?: "body" | "paper" | undefined
}

const ScrollDialog = (props:props) => {
 const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');
  const dialogBoxWidth = (props.dialogWidth !== undefined && props.dialogWidth !== false ? props.dialogWidth : "sm")

  const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  let content;
  if (props.children === undefined)
  {
    content = "No content"
  }
  else{
    content = props.children
  }

  return (
    <React.Fragment>
      <Button className={props.className} onClick={handleClickOpen(props.scrollType)}>{props.buttonContent}</Button>
      <Dialog
        maxWidth={dialogBoxWidth}
        fullWidth
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">{props.title}</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {content}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ScrollDialog;